import { ProductAPI } from "../api";
export class Product {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getProducts(payload) {
    const { data } = await ProductAPI.getProducts(payload);
    return data.result.map(item => new Product(item));
  }
}
